export default __webpack_public_path__ + "static/media/call.f33bbf8f.png";